if (!customElements.get('sa-icp-discount-copy')) {
  class SaIcpDiscountCopy extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.resetTimer = null;
    }

    connectedCallback() {
      this.button = this.querySelector('[data-discount-copy-button]');
      this.status = this.querySelector('[data-discount-copy-status]');
      if (!this.button) return;

      this.button.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.handleClick);
      }
      window.clearTimeout(this.resetTimer);
    }

    async handleClick() {
      const value = this.button?.dataset.copyValue;
      if (!value) return;

      const copied = await this.copy(value);
      if (!this.button?.isConnected) return;

      const feedbackLabel = copied
        ? this.button.dataset.copiedLabel
        : this.button.dataset.copyErrorLabel;
      this.classList.toggle('is-copied', copied);
      if (feedbackLabel) {
        this.button.setAttribute('aria-label', feedbackLabel);
        if (this.status) this.status.textContent = feedbackLabel;
      }

      window.clearTimeout(this.resetTimer);
      this.resetTimer = window.setTimeout(() => {
        const copyLabel = this.button?.dataset.copyLabel;
        this.classList.remove('is-copied');
        if (copyLabel && this.button) this.button.setAttribute('aria-label', copyLabel);
        if (this.status) this.status.textContent = '';
      }, 1500);
    }

    async copy(value) {
      if (navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(value);
          return true;
        } catch (_error) {
          return this.copyWithSelection(value);
        }
      }

      return this.copyWithSelection(value);
    }

    copyWithSelection(value) {
      const input = document.createElement('textarea');
      input.value = value;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();

      let copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (_error) {
        copied = false;
      }

      input.remove();
      this.button?.focus();
      return copied;
    }
  }

  customElements.define('sa-icp-discount-copy', SaIcpDiscountCopy);
}
